<template>
  <div class="container-message">
    <div class="row row-title">
      <div class="col color-white text-center">
        <h1>3. ESCRIBE EL MENSAJE</h1>
      </div>
    </div>

    <div class="row align-items-center justify-content-center">
      <div
        v-for="(m, index) of messages"
        :key="index"
        class="col-xl-4 col-lg-4 col-md-5 col-sm-12"
      >
        <div class="container-input-message" @click="focusTextArea(`textarea-${index}`)">
          <h3 v-if="m.message == ''">
            ¡Añade tu mensaje!<br>Maximo 30 caracteres
          </h3>
          <textarea
            :ref="`textarea-${index}`"
            class="textarea-message"
            v-model="m.message"
            maxlength="30"
          ></textarea>
          <div class="text-right">
            <img class="corazon" src="@/assets/store/diloconnieve/corazon.svg" alt="">
          </div>
        </div>
        <div v-if="messages.length > 1" class="text-left">
          <v-btn icon dark @click="removeMessage(index)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="row align-items-center justify-content-center">
      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 text-center">
        <v-btn text dark @click="addMessage">Agregar otro mensaje</v-btn>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: ['messages'],
  methods: {
    focusTextArea(key) {
      this.$refs[key][0].focus()
    },
    addMessage() {
      this.$emit('addMessage')
    },
    removeMessage(index) {
      this.$emit('removeMessage', index)
    },
  }
}
</script>

<style scoped>
.container-message {
  background-color: var(--color-primary);
  width: 100%;
  font-family: var(--font-baloo-regular);
  padding: 20px;
}
.container-message .row-title {
  margin-bottom: 2%;
  margin-top: 2%;
}
.img_message {
  width: 35%;
}
.container-input-message {
  border: 2px solid white;
  padding: 5%;
  text-align: center;
  color: white
}
.textarea-message {
  width: 90%;
  resize: none;
  overflow: auto;
  border: 0px;
  outline: 0px;
  background-color:transparent;
  font-size: 22px;
  color: white
}
.corazon {
  width: 10%;
}
@media only screen and (min-width: 768px) and (max-width: 1264px) {
  .container-message h1 {
    font-size: 30px !important;
  }
}
@media only screen and (min-width: 360px) and (max-width: 490px) {
  .container-message h1 {
    font-size: 22px !important;
  }
  .container-message h2 {
    font-size: 16px !important;
  }
  .container-message h5 {
    font-size: 14px !important;
  }
}
</style>
